import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SampleService } from '../../core/http/sample.service';
import { SettingsService } from '../../core/http/settings.service';
import { BillingService } from '../../core/http/billing.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ObsService } from '../../core/http/obs.service';
import { FinalizeModalComponent } from 'src/app/shared/components/finalize-modal/finalize-modal.component';
import { Location } from '@angular/common';

@Component({
  selector: 'app-result-finalise',
  templateUrl: './result-finalise.component.html',
  styleUrls: ['./result-finalise.component.scss'],
})
export class ResultFinaliseComponent implements OnInit {
  isLoading = true;
  obsLoad = true;
  isSaveLoading = false;
  mode = 'form';
  Errors = null;
  data: any = [];
  all: any = [];
  samples: any = [];
  Success;
  billId;
  id: string;
  message;
  record: any = [];
  templates: any = [];
  patient: any = [];
  startdate = '';
  enddate = '';
  clinicalHistory: string;
  verifyLoad: boolean = false;

  Template_Text = '';

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [['bold', 'italic'], ['fontSize']],
  };

  stateForm = new FormGroup({
    sample_id: new FormControl('', Validators.required),
    format_code: new FormControl(''),
    formatstr: new FormControl('', Validators.required),
    result_id: new FormControl(''),
  });

  constructor(
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private obs: ObsService,
    private sample: SampleService,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public bill: BillingService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.paramMap.get('billId');

    this.sample.getResultsById(this.id).subscribe(
      (resSuccess: any) => {
        this.isLoading = false;
        console.log(resSuccess);
        this.data = resSuccess.data.filter(
          (t) => t.department_name == 'LABORATORY' && t.is_verified == '1'
        );
        this.setting.getPatientById(this.data[0].patient_id).subscribe(
          (res: any) => {
            this.patient = res;
            console.log(this.patient);
          },
          (resErr) => {
            this.isLoading = false;
            this.Errors = resErr;
            console.log(resErr);
          }
        );
        this.isLoading = false;
        console.log(this.data);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }

  openFinalize() {
    console.log(this.id, 'nnnnnnnnnn');
    this.modal.openModal(FinalizeModalComponent, 'modal', { id: this.id });
  }

  getResult() {
    this.sample.getResultByVerify(this.id).subscribe(
      (resSuccess: any) => {
        this.data = resSuccess.data.filter(
          (t) => t.department_name == 'LABORATORY' && t.is_verified == '1'
        );
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }

  getTemplate(result_id) {
    this.sample.getdetails(result_id).subscribe(
      (resSuccess) => {
        this.templates = resSuccess;
        this.Template_Text = this.templates.data;
        this.stateForm.patchValue({
          formatstr: this.templates.data,
        });
        console.log(this.templates.data);
        console.log(this.templates);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }
  addRecord(item) {
    // this.stateForm.reset()
    if (item.service_name === 'Obstetric') {
      this.obs.addItem(item);
      this.router.navigateByUrl('/obs-finalize', { state: { patient: item } });
    } else {
      this.record = item;
      this.clinicalHistory = item.clinical_history;
      this.mode = 'wiz';
      this.Errors = '';
      this.getTemplate(item.result_id);
      this.stateForm.patchValue({
        sample_id: item.sample_id,
        format_code: item.format_code,
        result_id: item.result_id,
        bill_id: item.bill_id,
      });
      console.log(item);
    }
  }
  back() {
    this.mode = 'form';
  }
  backs() {
    this.router.navigateByUrl('/finalise-encounter');
  }
  done() {
    console.log(this.stateForm.value);
    this.isSaveLoading = true;
    this.Errors = null;
    this.Success = null;
    const { sample_id, format_code, formatstr, result_id } =
      this.stateForm.value;
    this.sample.postResultDetail(result_id, formatstr).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        console.log(resSuccess);

        if (this.message.success) {
          this.getResult();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          this.mode = 'form';
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('error');
          this._snackBar.open('Error Please Try Agian', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        this._snackBar.open('error: please try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
    // this.stateForm.patchValue({
    //   formatstr: this.Template_Text
    // });
    console.log(this.stateForm.value);
    // this._snackBar.open('Template Added Successfully', '', {
    //   duration: 2000,
    //   verticalPosition: 'top',
    // });
  }
  setTemplate(template) {
    this.Template_Text = template.Template_Text.replace(/"/g, "'");
  }

  pushOnline() {
    let lstLocalResultId = null;
    this.sample
      .pushOnline(
        this.record.result_id,
        '',
        '',
        lstLocalResultId,
        '',
        '',
        '',
        ''
      )
      .subscribe(
        (resSuccess) => {
          this.message = resSuccess;
          this.isSaveLoading = false;
          console.log(resSuccess);

          if (this.message.success) {
            this._snackBar.open('Sent Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            console.log('error');
            this._snackBar.open('Error Please Try Agian', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.isSaveLoading = false;
          this._snackBar.open('error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }

  updateIsVerifeid() {
    this.verifyLoad = true;
    const is_verify_action = true;
    const is_collect_action = true;
    const is_acknowledge_action = true;
    const { sample_id, bill_id } = this.stateForm.value;
    this.sample
      .updateIsVerified(
        sample_id,
        bill_id,
        is_verify_action,
        is_acknowledge_action,
        is_collect_action
      )
      .subscribe(
        (resSuccess) => {
          this.message = resSuccess;
          this.verifyLoad = false;
          console.log(resSuccess);

          if (this.message.success) {
            this.getResult();
            this.stateForm.reset();
            this._snackBar.open('Verified Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this.Errors = 'Not successful, please try again';
            console.log('error');
            this._snackBar.open('Error Please Try Agian', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.isSaveLoading = false;
          this.Errors = resErr;
          this._snackBar.open('error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }

  Submit(e) {
    // e.preventDefault();
    console.log(this.stateForm.value);
    this.isSaveLoading = true;
    this.Errors = null;
    this.Success = null;
    const { sample_id, format_code, formatstr, result_id } =
      this.stateForm.value;
    this.sample.postResultDetail(result_id, formatstr).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        console.log(resSuccess);

        if (this.message.success) {
          this.getResult();
          this.stateForm.reset();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('error');
          this._snackBar.open('Error Please Try Agian', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        this._snackBar.open('error: please try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  onSubmit(e) {
    // e.preventDefault();
    console.log(this.stateForm.value);
    this.isSaveLoading = true;
    this.Errors = null;
    this.Success = null;
    let is_finalized = true;
    const { formatstr, result_id } = this.stateForm.value;
    // this.sample
    //   .postResultDetail(
    //     result_id,
    //     formatstr,
    //   )
    //   .subscribe(
    //     (resSuccess) => {

    //       this.message = resSuccess
    //       this.isSaveLoading = false;
    //       this.stateForm.reset()

    //       if (this.message.success) {
    //         this.getResult()
    //         this._snackBar.open('Saved Successfully', '', {
    //           duration: 2000,
    //           verticalPosition: 'top',
    //         });
    //       }
    //       else {
    //         this.Errors = "Not successful, please try again"
    //         console.log("Error Please Try Agian")
    //         this._snackBar.open('Error Please Try Agian', '', {
    //           duration: 2000,
    //           verticalPosition: 'top',
    //         });
    //       }

    //     },
    //     (resErr) => {
    //       this.isSaveLoading = false;
    //       this.Errors = resErr;
    //       console.log(resErr)
    //     }
    //   );
    this.sample.postResultFinalize(result_id, is_finalized).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        console.log(resSuccess);

        if (this.message.success) {
          this.getResult();
          console.log(this);
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          this.stateForm.reset();
          window.location.reload();
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('error');
          this._snackBar.open('Result already Finalized', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        this._snackBar.open('Error: try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #print-section {
            width: 500px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }
}
